import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export const AdapterErrorResponse = z.object({
  error: z.string(),
}).openapi('AdapterErrorResponse');

export type AdapterErrorResponse = z.infer<typeof AdapterErrorResponse>;
